import { DiscountType } from "enums";
import { Media } from "types";

export enum ItemType {
  Post,
  Product,
  Article,
  Banner,
}

export type Item = {
  displayOrder: number;
  isPinned: boolean;
  creationTime: string;
  itemType: ItemType;
  viewCount: number;
  clickCount: number;
  likeCount: number;
  usedInOrderCount: number;
  alreadyLikedByMe: boolean;
  magazineItem: PostItem | ProductItem | ArticleItem | BannerItem;
};

export type PostItem = {
  id: string;
  creatorId: string;
  creationTime: string;
  title: string;
  description: string;
  hashtag: null | string[];
  roomIds: null | { id: string }[];
  likeCount: number;
  viewCount: number;
  clickCount: number;
  postType: null | {
    id: string;
    title:
      | null
      | {
          language: string;
          value: string;
        }[];
  };
  notInterested: boolean;
  isDraft: boolean;
  creatorFullName: string;
  alreadyLikedByMe: boolean;
  displayOrder: number;
  isPinned: boolean;
  visible: boolean;
};
export type ArticleItem = {
  id: string;
  creatorId: string;
  creationTime: string;
  title: string;
  description: string;
  hashtag: null | string[];
  roomIds: null | { id: string }[];
  likeCount: number;
  articleCategory: null | {
    id: string;
    title: null | { language: string; value: string }[];
    subCategories: null | string[];
  };
  photo: null | Media;
  extraLink: string;
  isDraft: boolean;
  notInterested: boolean;
  creatorFullName: string;
  displayOrder: number;
  alreadyLikedByMe: boolean;
  isPinned: boolean;
  visible: boolean;
  viewCount: number;
  clickCount: number;
};
export type ProductItem = {
  id: string;
  title: string;
  code: string;
  creationTime: string;
  description: string;
  category: string;
  extraLink: string;
  price: number;
  tax: null | {
    value: number;
    taxType: number;
  };
  discount: null | {
    value: number;
    discountType: DiscountType;
  };
  hashtag: null | string[];
  roomIds: null | { id: string }[];
  images: null | (Media & { displayOrder: number })[];
  attributes: null | { title: string; value: string }[];
  creatorId: string;
  creatorFullName: string;
  notInterested: boolean;
  alreadyLikedByMe: boolean;
  isDraft: boolean;
  subCategories: null | string[];
  viewCount: number;
  clickCount: number;
  usedInOrderCount: number;
  displayOrder: number;
  isPinned: boolean;
  visible: boolean;
  likeCount: number;
};
export type BannerItem = {
  id: string;
  title: string;
  subTitle: string;
  album: null | (Media & { displayOrder: number })[];
  bannerType: null | {
    id: string;
    title: null | { language: string; value: string }[];
    iconUrl: string;
  };
  creationTime: string;
  creatorId: string;
  isDraft: boolean;
  displayOrder: number;
  bannerPosition: number;
  isPinned: boolean;
  visible: boolean;
};
export type ArticleDetails = {
  id: string;
  creatorId: string;
  creationTime: string;
  title: string;
  description: string;
  hashtag: null | string[];
  roomIds: null | { id: string }[];
  likeCount: number;
  articleCategory: null | {
    id: string;
    title: null | { language: string; value: string }[];
    subCategories: string[];
  };
  photo: null | {
    id: string;
    url: string;
    thumbnailUrl: string;
    mimeType: string;
    volume: number;
  };
  extraLink: string;
  isDraft: boolean;
  notInterested: boolean;
  creatorFullName: string;
  displayOrder: number;
  alreadyLikedByMe: boolean;
  isPinned: boolean;
  visible: boolean;
  viewCount: number;
  clickCount: number;
};
export type ProductDetails = {
  id: string;
  title: string;
  code: string;
  creationTime: string;
  description: string;
  category: string;
  extraLink: string;
  price: number;
  tax: null | {
    value: number;
    taxType: number;
  };
  discount: {
    value: number;
    discountType: number;
  };
  hashtag: null | string[];
  roomIds: null | { id: string }[];
  images: null | (Media & { displayOrder: number })[];
  attributes: null | { title: string; value: string }[];
  creatorId: string;
  creatorFullName: string;
  notInterested: boolean;
  alreadyLikedByMe: boolean;
  isDraft: boolean;
  subCategories: null | string[];
  viewCount: number;
  clickCount: number;
  usedInOrderCount: number;
  displayOrder: number;
  isPinned: boolean;
  visible: boolean;
  likeCount: number;
};
